export const getLandingPageFeatureStyles = (_, { palette = {} }) => ({
  container: {
    width: '100%',
    minHeight: '800px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  innerContainer: {
    height: '100%',
    width: '1180px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  'innerContainer-xl': {
    width: '980px',
  },
  'innerContainer-l': {
    width: '720px',
    flexDirection: 'column',
    alignItems: 'center',
  },
  'innerContainer-m': {
    width: '560px',
    flexDirection: 'column',
    alignItems: 'center',
  },
  'innerContainer-s': {
    width: '360px',
    margin: '0px 16px',
    flexDirection: 'column',
    alignItems: 'center',
  },
  featureContainer: {
    margin: 'auto 80px auto 0px',
    flex: '1',
    '& .get-started-button': {
      height: '48px',
      fontSize: '16px',
      padding: '12px 24px',
      backgroundColor: `${palette.black} !important`,
    },
  },
  'featureContainer-l': {
    margin: '20px 0px 40px 0px',
  },
  'featureContainer-m': {
    margin: '20px 0px 40px 0px',
    '& .get-started-button-container': {
      display: 'flex',
      justifyContent: 'center',
      '& .get-started-button': {
        width: '100%',
        fontSize: '24px',
      },
    },
  },
  'featureContainer-s': {
    margin: '20px 0px 40px 0px',
    '& .get-started-button-container': {
      display: 'flex',
      justifyContent: 'center',
      '& .get-started-button': {
        width: '100%',
        fontSize: '24px',
      },
    },
  },
  '@keyframes animationIn': {
    from: { opacity: 0, transform: 'translateX(-100%)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  animationContainer: {
    margin: 'auto 0px',
    '& img': {
      maxWidth: '589px',
      maxHeight: '800px',
      objectFit: 'cover',
      objectPosition: 'top',
    },
    animation: '$animationIn 1s forwards',
  },
  'animationContainer-xl': {
    '& img': {
      maxWidth: '450px',
    },
  },
  'animationContainer-l': {
    '& img': {
      width: '100%',
      maxHeight: 'unset',
    },
  },
  'animationContainer-m': {
    '& img': {
      width: '100%',
      maxHeight: 'unset',
    },
  },
  'animationContainer-s': {
    '& img': {
      width: '100%',
      maxHeight: 'unset',
    },
  },
  animationContainerSmallScreen: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '37px',
  },
});
